import { useEffect } from 'react';
import { useActionsCommandPalette } from '../command-palette/index.tsx';

export const usePerformPendingCommandOnClose = () => {
	const { performDialogCloseCommand } = useActionsCommandPalette();
	useEffect(
		() => () => {
			performDialogCloseCommand();
		},
		[performDialogCloseCommand],
	);
};
